import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { RegionService } from '@lib/region/region.service';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { StoreZoneRequest, Zone, ZoneSingleResponse } from '@lib/api/models/zone';

@Component({
    selector: 'app-prompt-region-zone-status-change-dialog',
    imports: [ComponentsModule, ErrorPanelComponent],
    templateUrl: './prompt-region-zone-status-change-dialog.component.html',
    standalone: true,
    styleUrl: './prompt-region-zone-status-change-dialog.component.scss'
})
export class PromptRegionZoneStatusChangeDialogComponent {
  protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _regionService = inject(RegionService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly zone = inject<Zone>(DIALOG_DATA);

    updateZoneRequest = new SendableRequest<ZoneSingleResponse, StoreZoneRequest>({
        request: (payload) => this._regionService.updateZone(this.zone.id, payload!),
        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Zone status changed successfully',
                actions: [
                    { id: 'undo', label: 'OK'}
                ]
            });

            this.dialogRef.close();
        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Zone failed to change status',
                actions: [
                    { id: 'undo', label: 'OK'}
                ]
            });
        }
    });

    update(){
        this.updateZoneRequest.send(this.zone);
    }

    public static show(dialog: DialogService, data: Zone) {
        return dialog.openDialog<DialogRef, Zone>(PromptRegionZoneStatusChangeDialogComponent, {
                data
            }
        );
    }

}
